document.addEventListener("click", (event) => {
  if (!(event.target instanceof Element)) {
    return;
  }

  const userMenuDropdownToggle = event.target.closest(
    ".js-user-menu-dropdown-toggle"
  );

  if (!(userMenuDropdownToggle instanceof Element)) {
    return document
      .querySelector(".js-user-menu")
      ?.classList.remove("is-active");
  }

  userMenuDropdownToggle
    .closest(".js-user-menu")
    ?.classList.toggle("is-active");
});
